import { Notification, DangerousHtmlContent, variants } from '@eti/components';
import { useTranslation } from '@eti/providers';

const PaymentDisabledMessage = () => {
  const { t } = useTranslation();
  return (
    <Notification variant={variants.WARNING}>
      <DangerousHtmlContent content={t('PaymentPage.Disabled.Message')} />
    </Notification>
  );
};

export default PaymentDisabledMessage;
